import { css } from 'styled-components';
// Shared between options (pages or results per page) and the ellipsis
// margin-left and margin-right = -1 makes it so the page button overlaps with the divider,
// so when a button is selected, the spacers can't be seen.
export const liStyles = css `
  align-items: center;
  display: flex;
  height: 32px;
  list-style-type: none;
  margin: 0;
  padding: 0;
  text-align: center;
  margin-left: -1px;
  margin-right: -1px;
  white-space: nowrap;

  min-width: ${({ $wide }) => ($wide ? '50px' : '32px')};
`;
export const ulStyles = css `
  padding-inline-start: 0;
  display: flex;
  height: 32px;
  gap: 1px;
  margin: 0;
`;
export const selectableOptionStyles = css `
  display: flex;
  align-items: center;
  flex: 1;
  height: 100%;
  width: 100%;
  padding: 0;

  font-weight: bold;

  border: none;
  cursor: pointer;
  text-decoration: none;

  ${({ theme: { colors, font }, $selected }) => `
    color: ${$selected ? colors['gray-900'] : colors['blue-800']};
    background-color: ${$selected ? colors['gray-200'] : 'initial'};
    border-radius: 4px;
    font-size: ${font.body.sm.size};
    line-height: ${font.body.sm.lineHeight};
  `}
`;
//# sourceMappingURL=styles.js.map